import { render, staticRenderFns } from "./LoyaltyCollapse.vue?vue&type=template&id=ca9d8d08&scoped=true"
import script from "./LoyaltyCollapse.vue?vue&type=script&lang=ts"
export * from "./LoyaltyCollapse.vue?vue&type=script&lang=ts"
import style0 from "./LoyaltyCollapse.vue?vue&type=style&index=0&id=ca9d8d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9d8d08",
  null
  
)

export default component.exports